import * as z from "zod";
import { ShopperAgentConfigVersionMetaSchema } from "./shopper-agent-config-version-meta";

/** Version history, newest first — the feature-flag-style change log. */
export const getShopperAgentConfigVersions = {
  name: "getShopperAgentConfigVersions" as const,
  input: z.object({ limit: z.number().int().min(1).max(200).optional() }),
  output: z.object({ versions: z.array(ShopperAgentConfigVersionMetaSchema) }),
};
